/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace
     */
    name?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

